// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  width: 100%;
  height: 100vh;
}

.pokemonCardContainer {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  place-items: center;
  gap: 20px;
  margin-top: 20px;
}

.btn {
  padding: 30px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 25px;
}

.btn button {
  padding: 12px 35px;
  background-color: rgb(118, 196, 192);
  border: none;
  font-size: 16px;
  box-shadow: 12px 6px 15px 0px #4f4545;
  border-radius: 2px;
  color: white;
  cursor: pointer;
  transition: all 0.3s;
}

.btn button:hover {
  transform: translateY(6px);
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB","sourcesContent":[".App {\n  text-align: center;\n  width: 100%;\n  height: 100vh;\n}\n\n.pokemonCardContainer {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  place-items: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.btn {\n  padding: 30px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 25px;\n}\n\n.btn button {\n  padding: 12px 35px;\n  background-color: rgb(118, 196, 192);\n  border: none;\n  font-size: 16px;\n  box-shadow: 12px 6px 15px 0px #4f4545;\n  border-radius: 2px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.btn button:hover {\n  transform: translateY(6px);\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
